@file:OptIn(InternalResourceApi::class)

package flvtomp4_master.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/flvtomp4_master.app.shared.generated.resources/"

@delegate:ResourceContentHash(1_913_001_069)
internal val Res.font.noto_color_emoji: FontResource by lazy {
      FontResource("font:noto_color_emoji", setOf(
        ResourceItem(setOf(), "${MD}font/noto_color_emoji.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(670_898_432)
internal val Res.font.noto_sans_sc_black: FontResource by lazy {
      FontResource("font:noto_sans_sc_black", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_black.otf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_680_682_653)
internal val Res.font.noto_sans_sc_bold: FontResource by lazy {
      FontResource("font:noto_sans_sc_bold", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_bold.otf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_391_310_123)
internal val Res.font.noto_sans_sc_light: FontResource by lazy {
      FontResource("font:noto_sans_sc_light", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_light.otf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_567_995_058)
internal val Res.font.noto_sans_sc_medium: FontResource by lazy {
      FontResource("font:noto_sans_sc_medium", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_medium.otf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(608_662_642)
internal val Res.font.noto_sans_sc_regular: FontResource by lazy {
      FontResource("font:noto_sans_sc_regular", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_sc_regular.otf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("noto_color_emoji", Res.font.noto_color_emoji)
  map.put("noto_sans_sc_black", Res.font.noto_sans_sc_black)
  map.put("noto_sans_sc_bold", Res.font.noto_sans_sc_bold)
  map.put("noto_sans_sc_light", Res.font.noto_sans_sc_light)
  map.put("noto_sans_sc_medium", Res.font.noto_sans_sc_medium)
  map.put("noto_sans_sc_regular", Res.font.noto_sans_sc_regular)
}
